// default language when lang variable is not found in storage
export const defaultLang = 'en';
